export const LOADER_TYPES = Object.freeze({
  SKELETON: 'skeleton',
  MICKEY: 'mickey',
  UNIVERSAL: 'universal',
  ASTERIX: 'asterix',
  EFTELING: 'efteling',
  PHANTASIALAND: 'phantasialand',
  TOVERLAND: 'toverland',
  NIGLOLAND: 'nigloland',
  LE_PAL: 'le-pal',
  ENERGYLANDIA: 'energylandia',
  GRONA_LUND: 'grona-lund',
  SEAWORLD: 'seaworld',
  BUSCH_GARDENS: 'busch-gardens',
  LEGOLAND_FLORIDA: 'legoland-florida',
  EP_RULANTICA: 'ep-rulantica',
  PLOPSALAND: 'plopsaland',
  PORTAVENTURA: 'portaventura',
  FERRARI_LAND: 'ferrari-land',
  WALIBI: 'walibi',
  THORPE_PARK: 'thorpe-park',
  BELLEWAERDE: 'bellewaerde',
  BOBBEJAANLAND: 'bobbejaanland',
  GARDALAND: 'gardaland',
  MIRABILANDIA: 'mirabilandia',
  MOVIE_PARK_GERMANY: 'movie-park-germany',
  PARQUE_DE_ATRACCIONES_DE_MADRID: 'parque-de-atracciones-de-madrid',
  LOTTE_WORLD: 'lotte-world',
  KNOTTS: 'knotts'
});

export const SKELETON_TYPES = Object.freeze({
  ATTRACTIONS: 'attractions',
  RESTAURANTS: 'restaurants',
  SHOWS: 'shows'
});

const DISNEY_ROUTES = [
  '/',
  '/shows',
  '/restaurants',
  '/disney-adventure-world',
  '/walt-disney-studios',
  '/studios',
  '/disneyland-california',
  '/disney-california-adventure',
  '/disneyland-resort',
  '/magic-kingdom',
  '/epcot',
  '/hollywood-studios',
  '/animal-kingdom',
  '/tokyo-disneyland',
  '/tokyo-disneysea',
  '/shanghai-disneyland',
  '/hong-kong-disneyland-park',
  '/typhoon-lagoon',
  '/blizzard-beach'
];

const UNIVERSAL_ROUTES = [
  '/universal-studios-california',
  '/universal-studios-beijing',
  '/universal-studios-singapore',
  '/universal-studios',
  '/islands-of-adventure',
  '/epic-universe',
  '/volcano-bay'
];

const CUSTOM_LOADER_ROUTES = [
  ['/parc-asterix', LOADER_TYPES.ASTERIX],
  ['/efteling', LOADER_TYPES.EFTELING],
  ['/phantasialand', LOADER_TYPES.PHANTASIALAND],
  ['/toverland', LOADER_TYPES.TOVERLAND],
  ['/nigloland', LOADER_TYPES.NIGLOLAND],
  ['/le-pal', LOADER_TYPES.LE_PAL],
  ['/energylandia', LOADER_TYPES.ENERGYLANDIA],
  ['/grona-lund', LOADER_TYPES.GRONA_LUND],
  ['/seaworld-orlando', LOADER_TYPES.SEAWORLD],
  ['/busch-gardens-tampa', LOADER_TYPES.BUSCH_GARDENS],
  ['/legoland-florida', LOADER_TYPES.LEGOLAND_FLORIDA],
  ['/europa-park', LOADER_TYPES.EP_RULANTICA],
  ['/rulantica', LOADER_TYPES.EP_RULANTICA],
  ['/traumatica', LOADER_TYPES.EP_RULANTICA],
  ['/plopsaland-belgium', LOADER_TYPES.PLOPSALAND],
  ['/plopsaland-de-panne', LOADER_TYPES.PLOPSALAND],
  ['/ferrari-land', LOADER_TYPES.FERRARI_LAND],
  ['/portaventura', LOADER_TYPES.PORTAVENTURA],
  ['/walibi-rhone-alpes', LOADER_TYPES.WALIBI],
  ['/walibi-belgium', LOADER_TYPES.WALIBI],
  ['/walibi-holland', LOADER_TYPES.WALIBI],
  ['/thorpe-park', LOADER_TYPES.THORPE_PARK],
  ['/bellewaerde', LOADER_TYPES.BELLEWAERDE],
  ['/bobbejaanland', LOADER_TYPES.BOBBEJAANLAND],
  ['/gardaland', LOADER_TYPES.GARDALAND],
  ['/mirabilandia', LOADER_TYPES.MIRABILANDIA],
  ['/movie-park-germany', LOADER_TYPES.MOVIE_PARK_GERMANY],
  ['/parque-de-atracciones-de-madrid', LOADER_TYPES.PARQUE_DE_ATRACCIONES_DE_MADRID],
  ['/lotte-world', LOADER_TYPES.LOTTE_WORLD],
  ['/knotts-berry-farm', LOADER_TYPES.KNOTTS]
];

const normalizePathname = (pathname) => {
  const rawPath = typeof pathname === 'string' && pathname.trim() ? pathname : '/';
  const pathOnly = rawPath.split(/[?#]/)[0] || '/';
  const prefixedPath = pathOnly.startsWith('/') ? pathOnly : `/${pathOnly}`;
  return prefixedPath.length > 1 ? prefixedPath.replace(/\/+$/, '') : '/';
};

const matchesRoute = (pathname, route) => {
  if (route === '/') {
    return pathname === '/';
  }

  return pathname === route || pathname.startsWith(`${route}/`);
};

const resolveSkeletonType = (pathname) => {
  const segments = normalizePathname(pathname).split('/').filter(Boolean);

  if (segments.includes('restaurants')) {
    return SKELETON_TYPES.RESTAURANTS;
  }

  if (segments.includes('shows')) {
    return SKELETON_TYPES.SHOWS;
  }

  return SKELETON_TYPES.ATTRACTIONS;
};

export const getParkLoadingDescriptor = (pathname) => {
  const normalizedPathname = normalizePathname(pathname);
  const skeletonType = resolveSkeletonType(normalizedPathname);

  if (DISNEY_ROUTES.some((route) => matchesRoute(normalizedPathname, route))) {
    return {
      loaderType: LOADER_TYPES.MICKEY,
      skeletonType,
      isBranded: true
    };
  }

  if (UNIVERSAL_ROUTES.some((route) => matchesRoute(normalizedPathname, route))) {
    return {
      loaderType: LOADER_TYPES.UNIVERSAL,
      skeletonType,
      isBranded: true
    };
  }

  const customMatch = CUSTOM_LOADER_ROUTES.find(([route]) => matchesRoute(normalizedPathname, route));

  if (customMatch) {
    return {
      loaderType: customMatch[1],
      skeletonType,
      isBranded: true
    };
  }

  return {
    loaderType: LOADER_TYPES.SKELETON,
    skeletonType,
    isBranded: false
  };
};

export const hasBrandedParkLoader = (pathname) => getParkLoadingDescriptor(pathname).isBranded;
